import React, { useState } from 'react';

const PRESETS = [
  { label: 'Pomodoro (25:00)', min: 25, sec: 0 },
  { label: 'Short Break (5:00)', min: 5, sec: 0 },
  { label: 'Long Break (15:00)', min: 15, sec: 0 },
];

export default function SessionForm({ onStart, disabled }) {
  const [goal, setGoal] = useState('');
  const [minutes, setMinutes] = useState(25);
  const [seconds, setSeconds] = useState(0);

  const handleSubmit = e => {
    e.preventDefault();
    onStart(goal, minutes * 60 + Number(seconds));
  };

  const handlePreset = (min, sec) => {
    setMinutes(min);
    setSeconds(sec);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 340, margin: '0 auto', padding: 16, borderRadius: 10, background: '#f8f8f8', boxShadow: '0 2px 8px #eee' }}>
      <input
        type="text"
        placeholder="Goal name"
        value={goal}
        onChange={e => setGoal(e.target.value)}
        required
        style={{ width: '100%', padding: 8, marginBottom: 12, borderRadius: 6, border: '1px solid #ccc' }}
        disabled={disabled}
      />
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input
          type="number"
          min="0"
          max="99"
          value={minutes}
          onChange={e => setMinutes(Number(e.target.value))}
          required
          style={{ width: 60, padding: 8, borderRadius: 6, border: '1px solid #ccc' }}
          disabled={disabled}
        />
        <span style={{ alignSelf: 'center' }}>:</span>
        <input
          type="number"
          min="0"
          max="59"
          value={seconds}
          onChange={e => setSeconds(Number(e.target.value))}
          required
          style={{ width: 60, padding: 8, borderRadius: 6, border: '1px solid #ccc' }}
          disabled={disabled}
        />
        <span style={{ alignSelf: 'center' }}>min:sec</span>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {PRESETS.map(p => (
          <button type="button" key={p.label} onClick={() => handlePreset(p.min, p.sec)} style={{ flex: 1, padding: 6, borderRadius: 6, border: '1px solid #2d7d46', background: '#fff', color: '#2d7d46', fontWeight: 600, cursor: 'pointer' }} disabled={disabled}>{p.label}</button>
        ))}
      </div>
      <button type="submit" style={{ width: '100%', padding: 10, borderRadius: 6, background: '#2d7d46', color: '#fff', border: 'none', fontWeight: 600 }} disabled={disabled}>Start Session</button>
    </form>
  );
}
